import { useEffect, useRef } from "react";
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";

function SocketMobileScanner({ handleScanProduct }) {
  const buffer = useRef("");
  const timeoutRef = useRef(null);
  const inputRef = useRef(null);
  const callbackRef = useRef(handleScanProduct);
  const scanDelay = 150; // Optimized delay for HID mode

  // Keep callbackRef up to date
  useEffect(() => {
    callbackRef.current = handleScanProduct;
  }, [handleScanProduct]);

  const processScan = () => {
    if (buffer.current.length > 0) {
      callbackRef.current(buffer.current.trim());
      buffer.current = "";
      if (inputRef.current) {
        inputRef.current.value = ""; // Clear input value
      }
    }
  };

  const handleKeyDown = (e) => {
    // Ignore modifier keys to prevent them from interfering with buffer
    if (["Shift", "Control", "Alt", "Meta"].includes(e.key)) return;

    if (e.key === "Enter" || e.key === "Tab") {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      processScan(); // Process immediately on Enter or Tab
      return;
    }

    if (e.key.length === 1) {
      // Clear existing timeout only if we are adding a new character
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      buffer.current += e.key;

      // Set timeout to process the buffer after inactivity
      timeoutRef.current = setTimeout(processScan, scanDelay);
    }
  };

  useEffect(() => {
    const handleGlobalClick = (e) => {
      const target = e.target;

      // Check if clicking on or inside an interactive element
      // This includes common tags and ag-grid elements/modifiers
      const isInteractive = !!target.closest(
        'input, textarea, select, button, a, [role="button"], label, [tabindex="0"], .ag-root-wrapper, .MuiMenu-root, .MuiPopover-root'
      );

      if (!isInteractive && inputRef.current) {
        // Slightly longer delay to allow portalled menus or MUI transitions to settle
        setTimeout(() => {
          const currentActive = document.activeElement;
          const isNowFocused = !!currentActive?.closest(
            'input, textarea, select, button, a, [role="button"], label, [tabindex="0"], .ag-root-wrapper, .MuiMenu-root, .MuiPopover-root'
          );

          if (!isNowFocused && inputRef.current) {
            inputRef.current.focus();
          }
        }, 150);
      }
    };

    document.addEventListener("mousedown", handleGlobalClick);
    inputRef.current?.focus();

    return () => {
      document.removeEventListener("mousedown", handleGlobalClick);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <input
      ref={inputRef}
      type="text"
      autoFocus
      style={{
        opacity: 0,
        pointerEvents: "none",
        height: 0,
        // position: "absolute",
        // left: "-9999px",
        // top: "-9999px",
      }}
      onKeyDown={handleKeyDown}
      aria-hidden="true"
    />
  );
}

export default SocketMobileScanner;
